import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { IconButton } from '../index';
import MaterialTooltip from '@mui/material/Tooltip';

const StyledIconButton = styled(IconButton)<{ $flipIcon?: boolean; $activeAccent?: boolean; $filled?: boolean }>`
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.radius.small};

  svg {
    stroke: ${({ theme }) => theme?.palette?.gray};
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
    display: block;
  }

  &:hover {
    background-color: transparent;

    svg {
      stroke: ${({ theme }) => theme?.palette?.accentText};
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &.active {
    background-color: ${({ theme, $activeAccent }) => ($activeAccent ? theme.palette.accent : theme.palette.grey)};

    svg {
      stroke: ${({ theme }) => theme?.palette?.accentText};
    }

    img {
      transform: ${({ $flipIcon }) => ($flipIcon ? 'scaleX(-1)' : 'none')};
    }
  }

  &.filled {
    background-color: ${({ theme }) => theme.palette.grey};
  }

  &.material-icon {
    svg {
      stroke: none !important;
      fill: ${({ theme }) => theme?.palette?.text} !important;
    }

    &:hover {
      svg {
        fill: ${({ theme }) => theme?.palette?.error} !important;
      }
    }

    &.active {
      svg {
        fill: ${({ theme }) => theme?.palette?.accentText} !important;
      }
    }

    &:disabled {
      &:hover {
        svg {
          fill: ${({ theme }) => theme?.palette?.gray} !important;
        }
      }

      svg {
        fill: ${({ theme }) => theme?.palette?.grey} !important;
      }
    }
  }

  &.clear {
    background: none;
  }
`;

interface IconButtonRoundedProps {
  active?: boolean;
  title: string;
  icon: ReactNode;
  filled?: boolean;
  flipIcon?: boolean;
  activeAccent?: boolean;
  disabled?: boolean;
  materialIcon?: boolean;
  onClick?: any;
  clear?: boolean;
  testId?: string;
}

// materialIcon: enables correct fill behavior for Material UI icons.
export const IconButtonRounded: FC<IconButtonRoundedProps> = ({
  active,
  icon,
  title,
  flipIcon = false,
  activeAccent = false,
  filled = false,
  disabled = false,
  materialIcon = false,
  onClick,
  clear = false,
  testId = "IconButton",
}) => {
  return (
    <MaterialTooltip title={title} placement="top">
      <div>
        <StyledIconButton
          //@ts-ignore
          type="button"
          title={title}
          $flipIcon={flipIcon}
          $activeAccent={activeAccent}
          onClick={onClick}
          className={classNames({ active, filled, 'material-icon': materialIcon, clear: clear })}
          disabled={disabled}
          data-testid={testId}
        >
          <>{icon}</>
        </StyledIconButton>
      </div>
    </MaterialTooltip>
  );
};
